

import * as React from "react";
import * as SwitchPrimitives from "@radix-ui/react-switch";
import { Check } from "lucide-react";
import { cn } from "../../lib/utils";
import { Label } from "./label";

interface SwitchProps
  extends React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> {
  label?: string;
}

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  SwitchProps
>(({ label, className, ...props }, ref) => {
  const isChecked = props.checked ?? false;

  return (
    <div className="flex items-center space-x-3">
      {/* Label (left-aligned if desired) */}
      {label && (
        <Label
          htmlFor={props.id}
          className="text-md BookEZ_font_body_medium text-muted-foreground"
        >
          {label}
        </Label>
      )}

      {/* Switch */}
      <SwitchPrimitives.Root
        className={cn(
          "peer inline-flex h-7 w-14 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent bg-gray-300 dark:bg-zinc-700 transition-colors duration-300 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary",
          className
        )}
        {...props}
        ref={ref}
        id={props.id}
      >
        <SwitchPrimitives.Thumb
          className={cn(
            "pointer-events-none flex h-6 w-6 items-center justify-center rounded-full bg-white dark:bg-zinc-100 shadow-lg ring-0 transition-all duration-300 ease-in-out data-[state=checked]:translate-x-7 data-[state=unchecked]:translate-x-0"
          )}
        >
          <Check
            className={cn(
              "h-3.5 w-3.5 text-primary opacity-0 transition-opacity duration-200 ease-in-out",
              isChecked && "opacity-100"
            )}
          />
        </SwitchPrimitives.Thumb>
      </SwitchPrimitives.Root>
    </div>
  );
});

Switch.displayName = SwitchPrimitives.Root.displayName;

export { Switch };
